import React from 'react'

interface HiIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export const HiIcon = (props: HiIconProps) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <g clipPath="url(#clip0_12114_95081)">
        <path d="M1 1.19922H21V7.86719H1V1.19922Z" fill="#FF6820" />
        <path d="M1 7.86719H21V14.5312H1V7.86719Z" fill="white" />
        <path d="M1 14.5312H21V21.1992H1V14.5312Z" fill="#046A38" />
        <path
          d="M11.0006 13.9816C12.5369 13.9816 13.7824 12.7361 13.7824 11.1998C13.7824 9.66343 12.5369 8.41797 11.0006 8.41797C9.46421 8.41797 8.21875 9.66343 8.21875 11.1998C8.21875 12.7361 9.46421 13.9816 11.0006 13.9816Z"
          fill="#07038D"
        />
        <path
          d="M10.9996 13.6047C12.3284 13.6047 13.4055 12.5276 13.4055 11.1989C13.4055 9.87012 12.3284 8.79297 10.9996 8.79297C9.6709 8.79297 8.59375 9.87012 8.59375 11.1989C8.59375 12.5276 9.6709 13.6047 10.9996 13.6047Z"
          fill="white"
        />
        <path
          d="M10.9968 11.6811C11.2625 11.6811 11.478 11.4657 11.478 11.1999C11.478 10.9342 11.2625 10.7188 10.9968 10.7188C10.7311 10.7188 10.5156 10.9342 10.5156 11.1999C10.5156 11.4657 10.7311 11.6811 10.9968 11.6811Z"
          fill="#07038D"
        />
        <path
          d="M10.9965 8.79492L11.0867 10.2427L10.9965 10.9595L10.9062 10.2427L10.9965 8.79492Z"
          fill="#07038D"
        />
        <path
          d="M11.2956 8.91972C11.3533 8.92731 11.4061 8.88674 11.4137 8.8291C11.4213 8.77147 11.3807 8.71859 11.3231 8.711C11.2655 8.70342 11.2126 8.74399 11.205 8.80162C11.1974 8.85926 11.238 8.91213 11.2956 8.91972Z"
          fill="#07038D"
        />
        <path
          d="M11.0035 13.6055L10.9133 12.1577L11.0035 11.4409L11.0938 12.1577L11.0035 13.6055Z"
          fill="#07038D"
        />
        <path
          d="M10.7044 13.4807C10.6467 13.4731 10.5939 13.5137 10.5863 13.5713C10.5787 13.6289 10.6193 13.6818 10.6769 13.6894C10.7345 13.697 10.7874 13.6564 10.795 13.5988C10.8026 13.5411 10.762 13.4883 10.7044 13.4807Z"
          fill="#07038D"
        />
        <path
          d="M11.6262 8.87687L11.3386 10.2987L11.066 10.9677L11.1644 10.252L11.6262 8.87687Z"
          fill="#07038D"
        />
        <path
          d="M11.8839 9.07461C11.9376 9.09686 11.9992 9.07136 12.0214 9.01765C12.0436 8.96394 12.0181 8.90237 11.9644 8.88012C11.9107 8.85788 11.8492 8.88338 11.8269 8.93709C11.8047 8.9908 11.8302 9.05237 11.8839 9.07461Z"
          fill="#07038D"
        />
        <path
          d="M10.3738 13.5235L10.6614 12.1017L10.934 11.4327L10.8356 12.1484L10.3738 13.5235Z"
          fill="#07038D"
        />
        <path
          d="M10.1161 13.3258C10.0624 13.3035 10.0008 13.329 9.9786 13.3827C9.95636 13.4364 9.98186 13.498 10.0356 13.5203C10.0893 13.5425 10.1508 13.517 10.1731 13.4633C10.1953 13.4096 10.1698 13.348 10.1161 13.3258Z"
          fill="#07038D"
        />
        <path
          d="M12.2031 9.11542L11.5574 10.4143L11.1208 10.99L11.4011 10.3241L12.2031 9.11542Z"
          fill="#07038D"
        />
        <path
          d="M12.4007 9.37562C12.4468 9.41101 12.5129 9.40231 12.5482 9.35619C12.5836 9.31007 12.5749 9.244 12.5288 9.20861C12.4827 9.17322 12.4166 9.18192 12.3812 9.22804C12.3458 9.27416 12.3545 9.34023 12.4007 9.37562Z"
          fill="#07038D"
        />
        <path
          d="M9.78905 13.2811L10.4348 11.9821L10.8713 11.4065L10.5911 12.0724L9.78905 13.2811Z"
          fill="#07038D"
        />
        <path
          d="M9.59152 13.0228C9.5454 12.9874 9.47933 12.9961 9.44394 13.0422C9.40855 13.0884 9.41725 13.1544 9.46337 13.1898C9.50949 13.2252 9.57556 13.2165 9.61095 13.1704C9.64634 13.1243 9.63764 13.0582 9.59152 13.0228Z"
          fill="#07038D"
        />
        <path
          d="M12.7044 9.49934L11.7445 10.5869L11.1738 11.0299L11.6169 10.4593L12.7044 9.49934Z"
          fill="#07038D"
        />
        <path
          d="M12.8268 9.79955C12.8621 9.84567 12.9282 9.85437 12.9743 9.81898C13.0205 9.78359 13.0292 9.71752 12.9938 9.6714C12.9584 9.62528 12.8923 9.61658 12.8462 9.65197C12.8001 9.68736 12.7914 9.75343 12.8268 9.79955Z"
          fill="#07038D"
        />
        <path
          d="M9.29558 12.901L10.2555 11.8135L10.8262 11.3705L10.3831 11.9411L9.29558 12.901Z"
          fill="#07038D"
        />
        <path
          d="M9.17325 12.6008C9.13786 12.5547 9.07178 12.546 9.02567 12.5814C8.97955 12.6168 8.97085 12.6829 9.00624 12.729C9.04162 12.7751 9.1077 12.7838 9.15382 12.7484C9.19994 12.713 9.20864 12.647 9.17325 12.6008Z"
          fill="#07038D"
        />
        <path
          d="M13.0842 9.9961L11.8755 10.7981L11.2096 11.0784L11.7853 10.6419L13.0842 9.9961Z"
          fill="#07038D"
        />
        <path
          d="M13.127 10.3184C13.1493 10.3721 13.2109 10.3976 13.2646 10.3754C13.3183 10.3532 13.3438 10.2916 13.3215 10.2379C13.2993 10.1842 13.2377 10.1587 13.184 10.1809C13.1303 10.2032 13.1048 10.2647 13.127 10.3184Z"
          fill="#07038D"
        />
        <path
          d="M8.92364 12.4043L10.1323 11.6023L10.7982 11.322L10.2226 11.7585L8.92364 12.4043Z"
          fill="#07038D"
        />
        <path
          d="M8.88077 12.082C8.85853 12.0283 8.79695 12.0027 8.74325 12.025C8.68954 12.0472 8.66404 12.1088 8.68628 12.1625C8.70853 12.2162 8.7701 12.2417 8.82381 12.2195C8.87751 12.1972 8.90302 12.1357 8.88077 12.082Z"
          fill="#07038D"
        />
        <path
          d="M13.3202 10.5774L11.9451 11.0392L11.2294 11.1376L11.8984 10.8649L13.3202 10.5774Z"
          fill="#07038D"
        />
        <path
          d="M13.2816 10.9014C13.2892 10.959 13.342 10.9996 13.3997 10.992C13.4573 10.9844 13.4979 10.9315 13.4903 10.8739C13.4827 10.8163 13.4298 10.7757 13.3722 10.7833C13.3146 10.7909 13.274 10.8437 13.2816 10.9014Z"
          fill="#07038D"
        />
        <path
          d="M8.67977 11.823L10.0549 11.3612L10.7706 11.2628L10.1016 11.5354L8.67977 11.823Z"
          fill="#07038D"
        />
        <path
          d="M8.71841 11.499C8.71082 11.4414 8.65795 11.4008 8.60032 11.4084C8.54268 11.416 8.50211 11.4689 8.5097 11.5265C8.51729 11.5841 8.57016 11.6247 8.62779 11.6171C8.68543 11.6095 8.726 11.5567 8.71841 11.499Z"
          fill="#07038D"
        />
        <path
          d="M13.4141 11.1996L11.9663 11.2898L11.2495 11.1996L11.9663 11.1094L13.4141 11.1996Z"
          fill="#07038D"
        />
        <path
          d="M13.2854 11.5007C13.2778 11.5583 13.3183 11.6112 13.376 11.6188C13.4336 11.6264 13.4865 11.5858 13.4941 11.5282C13.5017 11.4706 13.4611 11.4177 13.4035 11.4101C13.3458 11.4025 13.2929 11.4431 13.2854 11.5007Z"
          fill="#07038D"
        />
        <path
          d="M8.59375 11.1988L10.0415 11.1086L10.7583 11.1988L10.0415 11.2891L8.59375 11.1988Z"
          fill="#07038D"
        />
        <path
          d="M8.72245 10.8977C8.73004 10.8401 8.68947 10.7872 8.63183 10.7796C8.5742 10.772 8.52133 10.8126 8.51374 10.8703C8.50615 10.9279 8.54672 10.9808 8.60436 10.9883C8.66199 10.9959 8.71487 10.9554 8.72245 10.8977Z"
          fill="#07038D"
        />
        <path
          d="M13.3282 11.8215L11.9064 11.534L11.2374 11.2613L11.9531 11.3597L13.3282 11.8215Z"
          fill="#07038D"
        />
        <path
          d="M13.1246 12.0792C13.1024 12.1329 13.1279 12.1945 13.1816 12.2167C13.2353 12.239 13.2968 12.2135 13.3191 12.1597C13.3413 12.106 13.3158 12.0445 13.2621 12.0222C13.2084 12 13.1468 12.0255 13.1246 12.0792Z"
          fill="#07038D"
        />
        <path
          d="M8.67179 10.575L10.0936 10.8625L10.7626 11.1352L10.0469 11.0368L8.67179 10.575Z"
          fill="#07038D"
        />
        <path
          d="M8.8754 10.3173C8.89764 10.2636 8.87214 10.202 8.81843 10.1798C8.76472 10.1575 8.70315 10.183 8.68091 10.2367C8.65866 10.2904 8.68416 10.352 8.73787 10.3743C8.79158 10.3965 8.85315 10.371 8.8754 10.3173Z"
          fill="#07038D"
        />
        <path
          d="M13.0877 12.4024L11.7888 11.7566L11.2131 11.3201L11.879 11.6003L13.0877 12.4024Z"
          fill="#07038D"
        />
        <path
          d="M12.8314 12.5999C12.796 12.646 12.8047 12.7121 12.8508 12.7475C12.897 12.7829 12.963 12.7742 12.9984 12.728C13.0338 12.6819 13.0251 12.6158 12.979 12.5805C12.9329 12.5451 12.8668 12.5538 12.8314 12.5999Z"
          fill="#07038D"
        />
        <path
          d="M8.92011 9.99609L10.219 10.6418L10.7947 11.0784L10.1288 10.7981L8.92011 9.99609Z"
          fill="#07038D"
        />
        <path
          d="M9.1764 9.79855C9.21179 9.75243 9.20309 9.68636 9.15697 9.65097C9.11085 9.61558 9.04478 9.62428 9.00939 9.6704C8.974 9.71652 8.9827 9.78259 9.02882 9.81798C9.07494 9.85337 9.14101 9.84467 9.1764 9.79855Z"
          fill="#07038D"
        />
        <path
          d="M12.7018 12.8997L11.6143 11.9398L11.1712 11.3691L11.7419 11.8122L12.7018 12.8997Z"
          fill="#07038D"
        />
        <path
          d="M12.3977 13.024C12.3516 13.0594 12.3429 13.1255 12.3783 13.1716C12.4137 13.2177 12.4797 13.2264 12.5259 13.191C12.572 13.1556 12.5807 13.0896 12.5453 13.0434C12.5099 12.9973 12.4438 12.9886 12.3977 13.024Z"
          fill="#07038D"
        />
        <path
          d="M9.30598 9.4987L10.3935 10.4586L10.8366 11.0293L10.2659 10.5862L9.30598 9.4987Z"
          fill="#07038D"
        />
        <path
          d="M9.6101 9.37442C9.65622 9.33903 9.66492 9.27296 9.62953 9.22684C9.59414 9.18072 9.52806 9.17202 9.48194 9.20741C9.43582 9.2428 9.42713 9.30887 9.46251 9.35499C9.4979 9.40111 9.56398 9.40981 9.6101 9.37442Z"
          fill="#07038D"
        />
        <path
          d="M12.2109 13.2834L11.4089 12.0747L11.1286 11.4088L11.5652 11.9845L12.2109 13.2834Z"
          fill="#07038D"
        />
        <path
          d="M11.8847 13.3243C11.831 13.3466 11.8055 13.4081 11.8277 13.4618C11.85 13.5155 11.9115 13.541 11.9653 13.5188C12.019 13.4965 12.0445 13.435 12.0222 13.3813C12 13.3276 11.9384 13.3021 11.8847 13.3243Z"
          fill="#07038D"
        />
        <path
          d="M9.79688 9.11505L10.5989 10.3237L10.8792 10.9896L10.4426 10.414L9.79688 9.11505Z"
          fill="#07038D"
        />
        <path
          d="M10.1231 9.07413C10.1768 9.05189 10.2023 8.99031 10.1801 8.93661C10.1578 8.8829 10.0963 8.8574 10.0426 8.87964C9.98885 8.90189 9.96335 8.96346 9.98559 9.01717C10.0078 9.07087 10.0694 9.09638 10.1231 9.07413Z"
          fill="#07038D"
        />
        <path
          d="M11.6316 13.5234L11.1697 12.1483L11.0714 11.4325L11.344 12.1016L11.6316 13.5234Z"
          fill="#07038D"
        />
        <path
          d="M11.3057 13.4808C11.248 13.4884 11.2075 13.5413 11.215 13.5989C11.2226 13.6565 11.2755 13.6971 11.3331 13.6895C11.3908 13.6819 11.4313 13.6291 11.4238 13.5714C11.4162 13.5138 11.3633 13.4732 11.3057 13.4808Z"
          fill="#07038D"
        />
        <path
          d="M10.3762 8.87509L10.8381 10.2502L10.9364 10.9659L10.6638 10.2969L10.3762 8.87509Z"
          fill="#07038D"
        />
        <path
          d="M10.7021 8.91763C10.7598 8.91004 10.8004 8.85717 10.7928 8.79954C10.7852 8.7419 10.7323 8.70133 10.6747 8.70892C10.617 8.71651 10.5765 8.76938 10.5841 8.82701C10.5916 8.88465 10.6445 8.92522 10.7021 8.91763Z"
          fill="#07038D"
        />
      </g>
      <path
        d="M11 0.699219C16.799 0.699219 21.5 5.40023 21.5 11.1992C21.5 16.9982 16.799 21.6992 11 21.6992C5.20101 21.6992 0.5 16.9982 0.5 11.1992C0.5 5.40023 5.20101 0.699219 11 0.699219Z"
        stroke="#D6D8DC"
      />
      <defs>
        <clipPath id="clip0_12114_95081">
          <path
            d="M1 11.1992C1 5.67637 5.47715 1.19922 11 1.19922C16.5228 1.19922 21 5.67637 21 11.1992C21 16.7221 16.5228 21.1992 11 21.1992C5.47715 21.1992 1 16.7221 1 11.1992Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
